export default __webpack_public_path__ + "static/logo-byggframtid-negativ-0c665f5b51168a101b798840531c384d.png";